module.exports = __webpack_public_path__ + "static/Accessibility-f2271691450cc32af9d8d1b9d45dc7ec.png";